<template>
  <section class="panel-section">
    <slot />  
  </section>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
$red: #E41429;
$blue: #5BC4F0;
$green: #85DE43;
$darkblue: #001691;

.panel-section {
  font-size: 2.91vw;
  margin: 0 auto;
  max-width: 800px;

  &--nobg {
    background: none;
    margin-top: 60px;

    .panel-section__header,
    .panel-section__description {
      margin-left: 14.6vw;
      margin-right: 14.6vw;

      @media screen and (min-width: 800px) {
        margin-left: 116px;
        margin-right: 116px;
      }
    }

    .panel-section__header {
      align-items: center;
      display: flex;
      padding-top: 20px;
    }
  }

  @media screen and (min-width: 550px) {
    font-size: 16px;
  }
}

.panel-section__info {
  background: url('https://amica.pl/theme/Modern/img/View/lodowki-do-zabudowy-2020/lodowka.png');
  background-position-x: 6.25vw;
  background-repeat: no-repeat;
  background-size: 31.25vw;
  padding: 8.34vw 0;
  padding-left: calc(31.25vw + 20px + 6.25vw);
  position: relative;

  @media screen and (min-width: 800px) {
    background-position-x: 50px;
    background-size: 250px;
    padding: 67px 0 67px 320px;
  }

  &--cool {
    background-position-y: top;
    min-height: 53vw;

    @media screen and (min-width: 800px) {
      min-height: 424px;
    }
    
    .panel-section__fridge-overlay {
      top: 5.3vw;

      @media screen and (min-width: 800px) {
        top: 42px;
      }
    }
  }

  &--adapt {
    background-position-y: calc(50% - 2.7vw);
    
    .panel-section__fridge-overlay {
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &--freeze {
    background-position-y: bottom;
    
    .panel-section__fridge-overlay {
      bottom: 2.6vw;

      @media screen and (min-width: 800px) {
        bottom: 21px;
      }
    }
  }

  &--left {
    background: none;
    padding-left: 4.17vw;
    padding-right: 45vw;
    padding-top: 0;

    @media screen and (min-width: 800px) {
      padding-left: 33px;
      padding-right: 360px;
    }
  }

  .panel-section__description {
    margin-bottom: 0;
  }
}

.panel-section__bg-img {
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px 0 0 0;
  height: calc(100% + 40px);
  position: absolute;
  right: 0;
  width: 50vw;

  @media screen and (min-width: 800px) {
    border-radius: 20px 20px 20px 0;
    width: 400px;
  }

  &--cool {
    background-image: url('../../assets/fridge-open.png');
    background-position: top center;
  }

  &--adapt {
    background-image: url('../../assets/fridge-open.png');
    background-position: center;
  }

  &--freeze {
    background-image: url('../../assets/freezer-open.png');
    background-position: bottom center;
  }
}

.panel-section__fridge-overlay {
  left: 8vw;
  position: absolute;
  width: 28vw;

  @media screen and (min-width: 800px) {
    left: 64px;
    width: 224px;
  }
}

.panel-section__header-img {
  display: block;
  margin: 0 auto;
  max-width: calc(100% - 6.25vw);
}

.panel-section__header {
  color: $red;
  margin-bottom: 20px;
  margin-right: 8vw;
}

.panel-section__icon {
  background-color: $red;
  border-radius: 7px;
  display: flex;
  height: 60px;
  margin-right: 20px;
  width: 60px;

  img {
    display: block;
    margin: auto;
    width: 100%;
  }
}

.panel-section__tab-name {
  color: initial;
  margin: 0 0 10px;
}

.panel-section__title,
.panel-section__subtitle {
  font-size: 1.7em;
  line-height: normal;
  margin: 0;
}

.panel-section__title {
  font-weight: bold;
}

.panel-section__description {
  margin-right: 8vw;
}

.feature-box {
  background-color: #F7FDFF;
  border: 2px solid;
  border-radius: 10px;
  margin: 0 4.17vw;
  padding: 40px;
  position: relative;

  @media screen and (min-width: 800px) {
    margin: 0 33px;
  }

  &--blue {
    background-color: #F7FDFF;
    border-color: $blue;

    .feature-box__item {
      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjMyMiIgaGVpZ2h0PSIxMiI+PHBhdGggZD0iTS4yNDkgMS45NTlhMS4yMSAxLjIxIDAgMCAxIC4xMTYtMS42QTEuMjU5IDEuMjU5IDAgMCAxIDEuOTkxLjI0NWw0Ljk3NiA0LjlhMS4yMTEgMS4yMTEgMCAwIDEgMCAxLjcxNGwtNC45NzYgNC45YTEuMjU5IDEuMjU5IDAgMCAxLTEuNjI2LS4xMTQgMS4yMSAxLjIxIDAgMCAxLS4xMTYtMS42TDQuMzI5IDZsLTQuMS00LjA0MXoiIGZpbGw9IiM1YmM0ZjAiLz48L3N2Zz4=");
    }

    .feature-box__btn {
      background-color: $blue;
    }
  }

  &--green {    
    background-color: #FAFFF7;
    border-color: $green;

    .feature-box__item {
      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjMyMiIgaGVpZ2h0PSIxMiI+PHBhdGggZD0iTS4yNDkgMS45NTlhMS4yMSAxLjIxIDAgMCAxIC4xMTYtMS42QTEuMjU5IDEuMjU5IDAgMCAxIDEuOTkxLjI0NWw0Ljk3NiA0LjlhMS4yMTEgMS4yMTEgMCAwIDEgMCAxLjcxNGwtNC45NzYgNC45YTEuMjU5IDEuMjU5IDAgMCAxLTEuNjI2LS4xMTQgMS4yMSAxLjIxIDAgMCAxLS4xMTYtMS42TDQuMzI5IDZsLTQuMS00LjA0MXoiIGZpbGw9IiM1YmM0ZjAiLz48L3N2Zz4=");
    }

    .feature-box__btn {
      background-color: $green;
    }
  }

  &--darkblue {    
    background-color: #F8F9FF;
    border-color: $darkblue;

    .feature-box__item {
      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjMyMiIgaGVpZ2h0PSIxMiI+PHBhdGggZD0iTS4yNDkgMS45NTlhMS4yMSAxLjIxIDAgMCAxIC4xMTYtMS42QTEuMjU5IDEuMjU5IDAgMCAxIDEuOTkxLjI0NWw0Ljk3NiA0LjlhMS4yMTEgMS4yMTEgMCAwIDEgMCAxLjcxNGwtNC45NzYgNC45YTEuMjU5IDEuMjU5IDAgMCAxLTEuNjI2LS4xMTQgMS4yMSAxLjIxIDAgMCAxLS4xMTYtMS42TDQuMzI5IDZsLTQuMS00LjA0MXoiIGZpbGw9IiM1YmM0ZjAiLz48L3N2Zz4=");
    }

    .feature-box__btn {
      background-color: $darkblue;
    }
  }
}

.feature-box__header {
  align-items: center;
  display: flex;
  margin-bottom: 20px;
}

.feature-box__icon {
  background-color: $red;
  border-radius: 7px;
  display: flex;
  flex-shrink: 0;
  height: 40px;
  margin-right: 20px;
  width: 40px;

  &--large {
    height: 60px;
    width: 60px;
  }

  img {
    display: block;
    margin: auto;
    width: 100%;
  }
}

.feature-box__title {
  font-size: 1.7em;
  font-weight: bold;
  margin-bottom: 0;

  &--red {
    color: $red;
  }
}

.feature-box__description {
  margin: 20px 0;

  &:last-child {
    margin-bottom: 0;
  }
}

.panel-section__separator-img {
  margin: -8.5vw 0;
  width: 100%;

  &--nomt {
    margin-top: 0;
  }

  @media screen and (min-width: 800px) {
    border-radius: 40px;
  }
}

.feature-box__list {
  list-style: none;
  margin: 30px 0 0;
  padding: 0;

  &--nomt {
    margin-top: 0;
  }
}

.feature-box__item {
  background-position: top 4px left;
  background-repeat: no-repeat;
  margin: 0;
  padding-left: 18px;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  strong {
    display: block;
  }
}

.feature-box__img {
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  max-width: 100%;
  object-fit: cover;

  &:not(img) {
    height: 42vw;
    max-height: 330px;
  }
}

.feature-box__nav {
  position: absolute;
  right: 30px;
  top: -20px;
}

.feature-box__btn {
  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS45OTYiIGhlaWdodD0iMTUuODQ3Ij48cGF0aCBkPSJNMTYuNTkgOC45NjhIMWEuOTkuOTkgMCAxIDEgMC0xLjk4MWgxNS41OWwtNS4zLTUuMjQ5YS45ODUuOTg1IDAgMCAxLS4zMTQtLjk4NiAxIDEgMCAwIDEgLjc0My0uNzI2IDEuMDA2IDEuMDA2IDAgMCAxIC45OTEuMzI1bDcgNi45MzNhLjk4NC45ODQgMCAwIDEgMCAxLjM4N2wtNyA2LjkzM2ExLjAwNyAxLjAwNyAwIDAgMS0xLjM1OC0uMDQyLjk4NC45ODQgMCAwIDEtLjA2Mi0xLjM0NHoiIGZpbGw9IiNkNWYyZmYiLz48L3N2Zz4=") center / 20px no-repeat;
  border: 0;
  border-radius: 10px;
  height: 40px;
  margin: 0;
  padding: 0;
  width: 60px;

  &--prev {
    transform: rotate(180deg);
    margin-right: 10px;
  }
}
</style>